module.exports = __webpack_public_path__ + "media/assets/images/common/logo-68e4f5272bcbffcb7e44454833069bf1.png";